import './dashboard.scss';
import { Row ,Col, Dropdown, Button} from 'react-bootstrap';
import { Link} from 'react-router-dom';
import { useState,useEffect } from 'react';
import numofRMsicon from '../../images/svg/numofrmsicon.svg';
import numofCustomicon from '../../images/svg/numofcustomicon.svg';
import complianceicon from '../../images/svg/complianceicon.svg';
import crosssellicon from '../../images/svg/cross-sellicon.svg';
import aumicon from '../../images/svg/aumicon.svg';
import portfolioGrowthicon from '../../images/svg/portfoliogrowthicon.svg';
import producticon from '../../images/svg/producticon.svg';
import upTrendicon from '../../images/svg/uptrendicon.svg';
import downTrendicon from '../../images/svg/downtrendicon.svg';
import noAlertimage from '../../images/svg/noalertimage.svg';
import alerticon from '../../images/svg/alerticon.svg';
import callTimeicon from '../../images/svg/calltimeicon.svg';
import jennieimage from '../../images/people/jennie.png';
//import jacksonimage from '../../images/people/jackson.png';
import rmList from '../../mocks/profiles/rmList.json';
//import smList from '../../mocks/profiles/smList.json';


function Dashboard() {
  const [SelectedPeriod, setSelectedPeriod] = useState('Last 30 days');
  //const [selectedMode, setSelectedMode] = useState('All');
  const [alertMode, setAlertMode]= useState('off');
  const [selectedRM] = useState(localStorage.getItem('RM') || 'Jennie');
  //const [selectedSM, setSelectedSM] = useState(localStorage.getItem('SM') || 'Jackson Lim');
  const [selectedCust] = useState(localStorage.getItem('customer') || 'Mr Tan');
  const [selectedDuration] = useState(localStorage.getItem('duration') || '1m 42s');
  const [rmImage, setRmImage] = useState(jennieimage); // Default image for Jennie
  //const [smImage, setSmImage] = useState(jacksonimage); // Default image for Jennie
  useEffect(() => {
    const selectedRMProfile = rmList.profile.find(profile => profile.name === selectedRM);
    if (selectedRMProfile) {
      setRmImage(selectedRMProfile.image);
    }
  }, [selectedRM]);
  /*useEffect(() => {
    const selectedSMProfile = smList.profile.find(profile => profile.name === selectedSM);
    if (selectedSMProfile) {
      setSmImage(selectedSMProfile.image);
    }
  }, [selectedSM]);*/

  const calltime= 2; //change this to adjust time of call in minutes
  const now = new Date(Date.now()-(60000)*calltime);
  const dayOptions = { weekday: 'long' };
  const day = now.toLocaleDateString('en-UK', dayOptions);
  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  const date = now.toLocaleDateString('en-UK', dateOptions);
  const timeOptions = { hour: 'numeric', minute: 'numeric',hour12: true };
  const time = now.toLocaleTimeString('en-UK', timeOptions);
  localStorage.removeItem('callSumData_local');
  localStorage.removeItem('qaPerfData_local');
  localStorage.removeItem('idealConversationData_local');
  localStorage.removeItem('trainingPlansData_local');
    return (
      <div className='page'>

        <Row className='pagerow'>
          <Col className="teamperformance">
            <Row className="sectionheader">
              <Col className="title">Team Performance</Col>
              <Col className='dropcol'>
                  <Dropdown className="dropmenu">
                  <Dropdown.Toggle  id="filter">
                    {SelectedPeriod}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="button" onClick={() => setSelectedPeriod('Last 30 days')}>Last 30 days</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => setSelectedPeriod('Last 3 months')}>Last 3 months</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => setSelectedPeriod('Last year')}>Last year</Dropdown.Item>
                  </Dropdown.Menu>
                  </Dropdown>
              </Col>
            </Row>
            
            <Row className='performancecontainer team'>
              <Row className='bubble'>
                <Row className='performancename'><img src= {numofRMsicon} alt="rm"/>Number of RMs</Row>
                <Row className='performanceinfo'>
                  <Col className='performancestat'>20</Col>
                  <Col className='trend'></Col>
                </Row>
              </Row>
              <Row className='bubble'>
                <Row className='performancename'><img src= {numofCustomicon} alt="customers"/>Number of Customers</Row>
                <Row className='performanceinfo'>
                  <Col className='performancestat'>1000</Col>
                  <Col className='trend uptrend'><img src= {upTrendicon} alt="uptrend"/>2%</Col>
                </Row>
              </Row>
              <Row className='bubble'>
                <Row className='performancename'><img src= {complianceicon} alt="compliance"/>Compliance</Row>
                <Row className='performanceinfo'>
                  <Col className='performancestat'>95%</Col>
                  <Col className='trend downtrend'><img src= {downTrendicon} alt="downtrend"/>2%</Col>
                </Row>
              </Row>
              <Row className='bubble'>
                <Row className='performancename'><img src= {crosssellicon} alt="percentage"/>Cross-sell</Row>
                <Row className='performanceinfo'> 
                  <Col className='performancestat'>1%</Col>
                  <Col className='trend downtrend'><img src= {downTrendicon} alt="downtrend"/>0.3%</Col>
                </Row>
              </Row>
              <Row className='bubble'>
                <Row className='performancename'><img src= {aumicon} alt="aum"/>AUM</Row>
                <Row className='performanceinfo'>
                  <Col className='performancestat'>300 Mn SGD</Col>
                  <Col className='trend uptrend'><img src= {upTrendicon} alt="uptrend"/>12%</Col>
                </Row>
              </Row>
              <Row className='bubble'>
                <Row className='performancename'><img src= {portfolioGrowthicon} alt="portfolio"/>Portfolio Growth</Row>
                <Row className='performanceinfo'>
                  <Col className='performancestat'>5%</Col>
                  <Col className='trend uptrend'><img src= {upTrendicon} alt="uptrend"/>8%</Col>
                </Row>
              </Row>
              <Row className='bubble'>
                <Row className='performancename'><img src= {producticon} alt="products"/>Products per Customer</Row>
                <Row className='performanceinfo'>
                  <Col className='performancestat'>3.7</Col>
                  <Col className='trend uptrend'><img src= {upTrendicon} alt="uptrend"/>0.5%</Col>
                </Row>
              </Row>
            </Row>
          </Col>
          
          <Col className="alertnotifications">
          <Row className="sectionheader">
              <Col className="title">Alert Notifications</Col>
              {/*<Col className='alertfilter'>
                <div className='filterby'>Filter By: </div>
                <Dropdown className='dropmenu'>
                  <Dropdown.Toggle  id="filter">
                    {selectedMode}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="button" onClick={() => setSelectedMode('All')}>All</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => setSelectedMode('Non-compliant')}>Non-compliant</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => setSelectedMode('Compliant')}>Compliant</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> 
              </Col>*/}
            </Row>
            <Row className={`alertcontainer ${alertMode}`} as="button" onClick={() => setAlertMode(alertMode => (alertMode === "off" ? "on" : "on"))}>
                <Row className={'noalert'} >
                  <Row>Calls of all Relationship Managers are compliant and up to standard</Row>
                  <Row className='noalertsubtext'>No action needed. Keep up the good work!</Row>
                  <Row><img src= {noAlertimage} alt="No Alerts"/></Row>
                </Row>
                <Row className={`alert ${alertMode} bubble`} >
                  <Row className='title'><img src= {alerticon} alt="Alert"/>Non-compliant Calls</Row>
                  <Row className='alertdetails'>
                    <Col className='rminfo'>
                      <Col className='profilepic'><img src= {rmImage} alt="Profile"/></Col>
                      <Col className='rmtext'><label className="rmName">{selectedRM}</label><label className="rm">Relationship Manager</label></Col>
                    </Col>
                    <Col className='callinfo'>
                      <Row className="firstRow">{day}, {date}</Row>
                      <Row className='secondRow'><img src= {callTimeicon} alt="Call Time"/>{time}</Row>
                    </Col>
                    <Col className='callduration'>
                      <Row className="firstRow">Duration</Row>
                      <Row className='secondRow'>{selectedDuration}</Row>
                    </Col>
                    <Col className='customername'>
                      <Row className="firstRow">Customer Name</Row>
                      <Row className='secondRow'>{selectedCust}</Row>
                    </Col>
                    <Col className='compliancerating'>
                      <Row className="firstRow">Call Compliance Rating</Row>
                      <Row className='secondRow'><label>Non-compliant</label></Row>
                    </Col>
                    <Col className='reviewbutton'>
                      <Button className="btn" as={Link} to="/calls">Review Call</Button>
                    </Col>
                  </Row>
                </Row>
            </Row>
          </Col>
          
        </Row>
          
        

      </div>
    );
  }
  
  export default Dashboard;